import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import { i18n } from '@/plugins/i18n'
import BaseMixin from '@/mixins/base'

Vue.config.productionTip = false

// TODO: beforeEach?
router.beforeEach((to, from, next) => {
  store.dispatch('auth/check').then(next)
  // Promise.all([store.dispatch('auth/check')]).then(next)
})

Vue.mixin(BaseMixin)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
